import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'separateArrayByCommasPipe',
    standalone: false
})
export class SeparateArrayByCommasPipe implements PipeTransform {
  transform<T>(array: T[], key: keyof T): string {
    if (!Array.isArray(array)) {
      return '';
    }

    return array
      .map(item => item[key] as string)
      .filter(name => name != null)
      .join(', ');
  }
}
